import { getEnv } from 'services/apiEnv.service';
import { get, post } from 'services/request.service';
import {
  SubmitTeamDashboardQueryPayload,
  TeamDashboardFilterEnums,
  TeamDashboardQueryResponse
} from './team-dashboard.types';

const BASE_URL = `${getEnv('IT_BASE_URL')}/team-dashboard-management`;

export const getTeamDashboardFilterEnums = async (): Promise<TeamDashboardFilterEnums> => {
  return (await get({ url: `${BASE_URL}/overview-filter-enums` })).data;
};

export const submitTeamDashboardQuery = async (
  data: SubmitTeamDashboardQueryPayload
): Promise<TeamDashboardQueryResponse> => {
  return (await post({ url: `${BASE_URL}/overview`, data })).data;
};

export const getTeamRequestsList = async (
  data: Record<string, any>,
  viewId: number
): Promise<any> => {
  const response = await post({ url: `${BASE_URL}/requests/${viewId}`, data });
  const output = {
    items: response.data,
    paginationMetadata: JSON.parse(response.headers.paginationmetadata),
    columnData: JSON.parse(response.headers.columndata),
    filterCount: JSON.parse(response.headers.filtercount)
  };
  return output;
};
